import React from 'react';

const variants = {
  gray: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200',
  blue: 'bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300',
  green: 'bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300',
  yellow: 'bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-300',
  red: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300',
  purple: 'bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300',
};

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
  lg: 'px-3 py-1 text-sm',
};

export function Badge({
  children,
  variant = 'gray',
  size = 'md',
  className = '',
  dot = false,
}) {
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {dot && (
        <span
          className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
            variant === 'green' ? 'bg-green-500' :
            variant === 'red' ? 'bg-red-500' :
            variant === 'yellow' ? 'bg-yellow-500' :
            variant === 'blue' ? 'bg-blue-500' :
            'bg-gray-500'
          }`}
        />
      )}
      {children}
    </span>
  );
}

// Pre-configured status badges
export function StatusBadge({ status }) {
  const config = {
    draft: { variant: 'gray', label: 'Draft' },
    pending_review: { variant: 'yellow', label: 'Pending Review' },
    sent: { variant: 'blue', label: 'Sent' },
    accepted: { variant: 'green', label: 'Accepted' },
    rejected: { variant: 'red', label: 'Rejected' },
  };

  const { variant, label } = config[status] || config.draft;

  return <Badge variant={variant} dot>{label}</Badge>;
}

// Risk level badge
export function RiskBadge({ level }) {
  const config = {
    low: { variant: 'green', label: 'Low Risk' },
    medium: { variant: 'yellow', label: 'Medium Risk' },
    high: { variant: 'red', label: 'High Risk' },
  };

  const { variant, label } = config[level] || config.low;

  return <Badge variant={variant} size="sm">{label}</Badge>;
}

export default Badge;
